.sn-value {
  &__card {
    display: flex;
    flex-direction: column;
    background-color: var(--background-color-secondary);
    border-radius: var(--radius-size-lg);
    overflow: hidden;

    @include above($breakpoint-desktop-md) {
      flex-direction: row;
      align-items: stretch;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    padding: map-get($spacings, md);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, xl);
    }

    @include above($breakpoint-desktop-md) {
      padding: map-get($spacings, 2xl);
      flex: 1;
      min-width: 0;
    }
  }

  &__image {
    @include above($breakpoint-desktop-md) {
      width: 715px;
      height: 441px;
      flex-shrink: 0;
    }

    me-picture,
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
